<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :hot-key-create-path="'/purchase-order/create'"
    :hot-key-grid-tab-index="1"
    :has-auto-comp="true"
    :hot-key-expand="expandGrid"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Purchase Order"
        :baseView="baseView"
        :primaryLabel="model.Name"
        :secondaryLabel="model.Supplier.Name"
        v-if="model.Name"
      />
    </template>

    <!-- <gc-tabs
      :tabs="tabs"
      :selected-index.sync="selectedIndex"
      v-if="applicationMode == 'GcorpRoam'"
    /> -->
    <DxToolbar class="view-toolbar purchase-order-toolbar">
      <DxItem
        widget="dxForm"
        location="before"
        :options="{
          formData: model,
          items: toolbarFormItems,
          colCount: 2,
          validationGroup: 'toolbarForm',
          labelLocation: 'left',
          ref: 'sotoolbarform',
          disabled: baseView.mode == 'review' ? true : false,
        }"
        locate-in-menu="auto"
        :disabled="baseView.mode == 'review' ? true : false"
        ref="so-toolbar-form"
      ></DxItem>

      <DxItem
        widget="dxForm"
        location="after"
        :options="{
          formData: model,
          items: toolbarActiveItems,
          validationGroup: 'toolbarForm-2',
          labelLocation: 'left',
          disabled: baseView.mode == 'review' ? true : false,
        }"
        :disabled="baseView.mode == 'review' ? true : false"
        locate-in-menu="auto"
      ></DxItem>

      <DxItem #default location="after" locate-in-menu="auto">
        <gc-status-chip :status="statusFreindly" />
      </DxItem>
      <DxItem
        :options="toolbar.audit"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        v-if="baseView.mode == 'review'"
      />
      <DxItem
        :options="toolbar.notes"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
      />
      <DxItem
        :options="toolbar.copy"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        v-if="baseView.mode == 'review'"
      />
      <DxItem
        :options="toolbar.edit"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        v-if="baseView.mode == 'review'"
        :visible.sync="isEditVisible"
      />
      <DxItem
        :options="toolbar.save"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        v-if="baseView.mode != 'review'"
        ref="headerSaveMenu"
      />

      <template #agentTemplate="{ data }">
        <div class="toolbar-auto-complete">
          <span class="title">{{ data.Name }}</span>
          <span class="sub-title" style="color: grey">{{ data.Code }}</span>
        </div>
      </template>
    </DxToolbar>

    <DxPopup
      :visible.sync="lineCommentsPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      title="Line Comment"
      :width="550"
      :height="280"
      :showCloseButton="false"
    >
      <form>
        <DxForm
          :ref="'line-comments-form'"
          :customizeItem="customizeLineCommentItem"
          :form-data.sync="lineCommentModel"
          :items="lineCommentItems"
          :label-location="formsConfig.labelPosition"
        ></DxForm>
      </form>

      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="popupLineCommentBackButtonClick"
        />
      </div>
    </DxPopup>

    <DxPopup
      :visible.sync="commentsPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      title="Purchase Order Comments"
      :width="550"
      :height="700"
      :showCloseButton="false"
    >
      <form>
        <DxForm
          :ref="'comments-form'"
          :customizeItem="customizeItem"
          :form-data.sync="model"
          :items="commentItems"
          height="530"
          :scrolling-enabled="true"
        ></DxForm>
      </form>

      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="popUpBackButtonClick"
        />
      </div>
    </DxPopup>
    <div
      v-show="!this.gridExpanded"
      class="view-card responsive-paddings purchase-order-form"
    >
      <form v-if="dataLoaded">
        <DxForm
          :form-data.sync="model"
          :read-only="false"
          :show-colon-after-label="false"
          :show-validation-summary="false"
          :validation-group="formsConfig.validationGroup"
          :label-location="formsConfig.labelPosition"
          :customizeItem="customizeItem"
          :items="headerFormItems"
          :show-required-mark="false"
          @content-ready="onFormContentReady"
          ref="so-header-form"
        >
          <template #editAddressTemplate>
            <div class="edit-address-btn">
              <span @click="editDeliveryAddress">
                <a>
                  {{ baseView.mode == "review" ? "View" : "Edit" }}
                </a>
              </span>
            </div>
          </template>
        </DxForm>
      </form>
    </div>

    <div v-if="dataLoaded">
      <dx-data-grid
        class="purchase-order-grid"
        :data-source="purchaseOrderDetailsDataSourceConfig"
        :ref="poDetailsGridRefName"
        :columns="gridColumns"
        :reshape-on-push="true"
        :column-chooser="{ enabled: false }"
        @toolbar-preparing="onToolbarPreparingPoDetails($event)"
        :height="
          !gridExpanded
            ? gridHeight - (formHeight + toolbarHeight)
            : gridHeight - toolbarHeight
        "
        @cell-click="onPoDetailsColumnHeaderClick"
        @initialized="onPoDetailsInitialized"
        @cell-prepared="onCellPrepared"
        @content-ready="addGridNoResults($event)"
        :selection="{ mode: 'single' }"
      >
        <DxEditing
          :allow-updating="true"
          :select-text-on-edit-start="true"
          start-edit-action="click"
          mode="batch"
        />

        <template #primaryImageTemplate="{ data }">
          <div>
            <GcGridProductImage
              :ItemCode="data.data.ItemCode"
              :HasPrimaryImage="data.data.HasPrimaryImage"
              :Description="data.data.ItemDescription"
            />
          </div>
        </template>

        <template #itemBranch="{ data }">
          <div class="custom-auto-complete">
            <span class="auto-complete-primary">{{ data.Code }}</span>
            <span class="auto-complete-secondary">{{ data.Description }}</span>
          </div>
        </template>
        <template #itemDivision="{ data }">
          <div class="custom-auto-complete">
            <span class="auto-complete-primary">{{ data.Code }}</span>
            <span class="auto-complete-secondary">{{ data.Description }}</span>
          </div>
        </template>

        <template #qtyEditTemplate="{ data: cellInfo }">
          <div>
            <div>
              <DxNumberBox
                :value="cellInfo.value"
                @value-changed="onQuantityChanged($event, cellInfo)"
                :disabled="
                  baseView.mode == 'review' ||
                  model.Status === 'C' ||
                  model.Status === 'X' ||
                  cellInfo.data.LineStatus == 'C' ||
                  cellInfo.data.LineStatus == 'X'
                "
                :format="getDecimalFormatByCode(2).Format"
                class="gc-grid-number-box-editor"
                :min="-99999999"
                :max="99999999"
              />
            </div>
          </div>
        </template>

        <template #qtyEditTemplate2="{ data: cellInfo }">
          <div>
            <div>
              <DxNumberBox
                :value="cellInfo.value"
                @value-changed="onQuantityChanged($event, cellInfo)"
                :disabled="
                  baseView.mode == 'review' ||
                  model.Status === 'C' ||
                  model.Status === 'X' ||
                  cellInfo.data.LineStatus == 'C' ||
                  cellInfo.data.LineStatus == 'X'
                "
                :format="getDecimalFormatByCode(2).Format"
                class="gc-grid-number-box-editor"
                :min="-99999999"
                :max="99999999"
              />
            </div>
          </div>
        </template>

        <template #etaEditTemplate="{ data: cellInfo }">
          <div>
            <div>
              <DxDateBox
                :value="cellInfo.value"
                @value-changed="onDateChanged($event, cellInfo)"
                display-format="dd MMM yyyy"
                class="gc-grid-number-box-editor"
                :disabled="
                  baseView.mode == 'review' ||
                  model.Status === 'C' ||
                  model.Status === 'X' ||
                  cellInfo.data.LineStatus == 'C' ||
                  cellInfo.data.LineStatus == 'X' ||
                  (cellInfo.data.LineStatus == 'A' &&
                    cellInfo.data.SupplierReceivedQty > 0)
                "
              />
            </div>
          </div>
        </template>

        <template #requiredByEditTemplate="{ data: cellInfo }">
          <div>
            <div>
              <DxDateBox
                :value="cellInfo.value"
                @value-changed="onDateChanged($event, cellInfo)"
                display-format="dd MMM yyyy"
                class="gc-grid-number-box-editor"
                :disabled="
                  baseView.mode == 'review' ||
                  model.Status === 'C' ||
                  model.Status === 'X' ||
                  cellInfo.data.LineStatus == 'C' ||
                  cellInfo.data.LineStatus == 'X' ||
                  (cellInfo.data.LineStatus == 'A' &&
                    cellInfo.data.SupplierReceivedQty > 0)
                "
              />
            </div>
          </div>
        </template>

        <template #branchEditTemplate="{ data: cellInfo }">
          <div class="gc-auto-cmp-editor">
            <GcBranchAutoComplete
              :on-value-changed="onBranchChanged"
              :ref="'branch' + cellInfo.rowIndex"
              :data-source="getBranchDataSource()"
              :value="cellInfo.value"
              :cell-info="cellInfo"
              :disabled="
                cellInfo.data.LineStatus == 'C' ||
                cellInfo.data.LineStatus == 'X' ||
                (cellInfo.data.LineStatus == 'A' &&
                  cellInfo.data.SupplierReceivedQty > 0)
              "
            />
          </div>
        </template>

        <template #divisionEditTemplate="{ data: cellInfo }">
          <div class="gc-auto-cmp-editor">
            <GcBranchAutoComplete
              :on-value-changed="onDivisionChanged"
              :ref="'division' + cellInfo.rowIndex"
              :data-source="getDivisionDataSource()"
              :value="cellInfo.value"
              :cell-info="cellInfo"
            />
          </div>
        </template>

        <template #branch-template="{ data }">
          <div class="gc-auto-cmp">
            {{ data.data.BranchDescription }}
          </div>
        </template>

        <template #division-template="{ data }">
          <div class="gc-auto-cmp">
            {{ data.data.DivisionDescription }}
          </div>
        </template>

        <template #priceEditTemplate="{ data: cellInfo }">
          <div>
            <div>
              <DxNumberBox
                :value="cellInfo.value"
                @value-changed="onPriceChanged($event, cellInfo)"
                :disabled="
                  baseView.mode == 'review' ||
                  model.Status === 'C' ||
                  model.Status === 'X'
                "
                :format="getDecimalFormatByCode(7).Format"
                class="gc-grid-number-box-editor"
                :min="0"
                :max="99999999.99"
              />
            </div>
          </div>
        </template>

        <template #eta-cell-template="{ data }">
          <div>
            <gc-friendly-date :date="data.data.ETADate" />
          </div>
        </template>
        <template #required-by-cell-template="{ data }">
          <div>
            <gc-friendly-date :date="data.data.RequiredByDate" />
          </div>
        </template>
        <!-- <template #statusTemplate>
          <gc-status-chip :status="statusFreindly" />
        </template> -->
        <template #menu-cell-template="{ data }">
          <DxDropDownButton
            :items="[{ menuText: 'Line Comment', data: data }]"
            keyExpr="menuText"
            displayExpr="menuText"
            :drop-down-options="{ width: 250 }"
            class="gc-dropdown-icon-button"
            :id="data.data.ItemCode"
            :icon="poDetailsLineContextMenu.icon"
            styling-mode="text"
            :show-arrow-icon="false"
            :onItemClick="onPoDetailsLineContextMenuItemClick"
            :visible="formsConfig.editableOption"
          />
        </template>
      </dx-data-grid>
    </div>

    <gc-edit-delivery-address
      :setVisible="visibleEditDeliveryAddress"
      :formModel="model"
      :CustomerCode="model.CustomerCode"
      :callBack="deliveryAddressCallBack"
      :formItems="deliveryAddressFormItems"
    >
    </gc-edit-delivery-address>

    <template #footer>
      <GcFooterSalesOrder
        :CurrencyCode="model.CurrencyCode"
        :ItemCount="computedItemCount"
        :ExTaxTotal="computedExTaxTotal"
        :TaxTotal="computedTaxTotal"
        :Total="computedTotal"
      />
    </template>
  </gc-main-layout>
</template>

<script>
import validationEngine from "devextreme/ui/validation_engine";

import BaseViewMixin from "../../v1/_mixins/base.view";
import { BranchService } from "../../_services/api/sales/branch.service";
import { DivisionService } from "../../_services/api/sales/division.service";
import { FactorService } from "../../_services/api/sales/factor.service";
import { SalesOrderNoteService } from "../../_services/api/sales/sales-order-note.service";
import { PurchaseOrderDetail } from "../../_services/api/purchasing/purchase-order-detail.service";
import { GLChartService } from "../../_services/api/inventory/gl-chart.service";
import { ProductPurchaseService } from "../../_services/api/purchasing/product-purchase.service";
import { mapGetters } from "vuex";
import { AgentSupplierService } from "../../_services/api/accounts/agent-supplier.service";
import { CompanyCurrencyService } from "../../_services/api/accounts/company-currency.service";
import { CompanyService } from "../../_services/api/accounts/company.service";

import { compareValues } from "../../_helpers/collections/array-helper";
import { alert } from "devextreme/ui/dialog";
import { PurchaseOrder } from "../../_services/api/purchasing/purchase-order.service";

let poGlobalModel = {
  DefaultBranchCode: null,
  DefaultDivisionCode: null,
  DefaultBranchDescription: null,
  DefaultDivisionDescription: null,
};

let poDetailsSortExpr = null;
let poDetailsGridInstance = null;
let reviewModeSearchText = "";

let poDetailsBaseRecord = {
  B2BSupplierLineNo: "",
  BranchCode: "",
  ChangedBy: "",
  Comment: "",
  CompanyCode: "",
  DiscPcnt: 0,
  DivisionCode: "",
  FXLineTotal: 0,
  SupplierFXPrice: 0,
  HasPrimaryImage: false,
  IsBatchProduct: "",
  IsoNote: 0,
  IsPrimeCostItem: false,
  IsVariable: "",
  ItemCode: "",
  ItemDescription: "",
  ProductCode: "",
  ProductDescription1: "",
  Code: "",
  Description: "",
  ItemType: "",
  KitVersion: 0,
  LineNo: 0,
  LineStatus: "",
  LineTotal: 0,
  OutstandingQuantity: 0,
  Price: 0,
  PurchaseOrderCode: 0,
  ReceivedQty: 0,
  RecordId: "",
  RequiredQty: 0,
  SalesOrderCode: 0,
  SalesOrderLineNo: 0,
  SalesQuoteCode: null,
  SupplierConversion: 1,
  SupplierOutstandingQuantity: 0,
  SupplierPartNo: "",
  SupplierReceivedQty: 0,
  SupplierRequired: 0,
  SupplierUM: "",
  TakeOffReference: 0,
  TaxCode: "",
  TaxPcnt: 0,
  UnitOfMeasureCode: "",
  WorkOrderCode: 0,
  Rank: "",
  isNewRecord: false,
};

var poDetailsReviewListDataSource = PurchaseOrderDetail.dataSourceConfig({
  // sort: [{ selector: "ItemCode", asc: true }],
  // pageSize: 50,
  postProcess: (data) => {
    data.forEach((row, dIndex) => {
      data[dIndex] = Object.assign({}, data[dIndex], {
        ProductCode: data[dIndex].ItemCode,
        ProductDescription1: data[dIndex].ItemDescription,
        Code: data[dIndex].ItemCode,
        Description: data[dIndex].ItemDescription,
      });
    });
    return data;
  },
  key: "ItemCode",
  preventPagination: true,
});

var poDetailsProductListDataSource = ProductPurchaseService.dataSourceConfig(
  "api/ProductPurchaseList",
  {
    // sort: [{ selector: "ProductCode", asc: true }],
    postProcess: (data) => {
      let foundIndexes = [];
      data.forEach((row, dIndex) => {
        if (row.ProductCode == "") return;

        let foundIndex = poDetailsReviewListDataSource
          .items()
          .findIndex((x) => x.ItemCode == row.ProductCode);

        if (foundIndex > -1) {
          data[dIndex] = poDetailsReviewListDataSource.items()[foundIndex];
          foundIndexes.push(foundIndex);
        } else {
          let defaultRequiredByDate = new Date();
          defaultRequiredByDate.setDate(
            defaultRequiredByDate.getDate() + row.SupplierLead
          );
          let productListRecord = Object.assign({}, poDetailsBaseRecord, {
            RequiredByDate: defaultRequiredByDate,
            ETADate: defaultRequiredByDate,
          });

          data[dIndex] = Object.assign(productListRecord, row, {
            ItemCode: row.ProductCode,
            ItemDescription: row.ProductDescription1,
            Code: row.ProductCode,
            Description: row.ProductDescription1,
            BranchCode: poGlobalModel.DefaultBranchCode,
            BranchDescription: poGlobalModel.DefaultBranchDescription,
            DivisionDescription: poGlobalModel.DefaultDivisionDescription,
            ItemType: "S",
            DivisionCode: poGlobalModel.DefaultDivisionCode,
            TaxCode: row.TaxCode,
            TaxPcnt: row.TaxPcnt,
          });
        }
      });

      let uniqueIndexes = [...new Set(foundIndexes)];

      poDetailsReviewListDataSource.items().forEach((item, index) => {
        if (uniqueIndexes.indexOf(index) == -1 && item.ItemType !== "G") {
          data.push(item);
        }
      });

      if (poDetailsGridInstance) data = data.filter(filterFunction);

      return data;
    },
  }
);

var poDetailsGlChartDataSource = GLChartService.dataSourceConfig(
  "api/GLChart",
  {
    // sort: [{ selector: "Code", asc: true }],
    postProcess: (data) => {
      let foundIndexes = [];
      data.forEach((row, dIndex) => {
        row.ItemCode = row.Code.toString();

        let foundIndex = poDetailsReviewListDataSource
          .items()
          .findIndex((x) => x.ItemCode == row.ItemCode);

        if (foundIndex > -1) {
          data[dIndex] = poDetailsReviewListDataSource.items()[foundIndex];
          foundIndexes.push(foundIndex);
        } else {
          let productListRecord = Object.assign({}, poDetailsBaseRecord, {
            RequiredByDate: new Date(),
            ETADate: new Date(),
          });

          data[dIndex] = Object.assign(productListRecord, row, {
            ItemCode: row.ItemCode,
            ItemDescription: row.Description,
            ProductCode: row.ItemCode,
            ProductDescription1: row.Description,
            BranchCode: poGlobalModel.DefaultBranchCode,
            ItemType: "G",
            DivisionCode: poGlobalModel.DefaultDivisionCode,
            BranchDescription: poGlobalModel.DefaultBranchDescription,
            DivisionDescription: poGlobalModel.DefaultDivisionDescription,
            SupplierUM:"Ea",
            Rank: 1,
            IsVariable: "N",
            IsBatchProduct: "No",
          });
        }
      });
      let uniqueIndexes = [...new Set(foundIndexes)];

      poDetailsReviewListDataSource.items().forEach((item, index) => {
        if (uniqueIndexes.indexOf(index) == -1 && item.ItemType !== "S") {
          data.push(item);
        }
      });

      if (poDetailsSortExpr) {
        data.sort(
          compareValues(
            poDetailsSortExpr.dataField,
            poDetailsSortExpr.sortOrder
          )
        );
      }
      // this.$logger.debug("GLChart Data to be filtered", data);

      if (poDetailsGridInstance) data = data.filter(filterFunction);

      return data;
    },
  }
);

var currentRowIndex = -1;

// eslint-disable-next-line no-unused-vars
let filterFunction = (x) => {
  return (
    x.ItemCode.toLowerCase().indexOf(
      poDetailsGridInstance._options._optionManager._options.searchPanel.text.toLowerCase()
    ) !== -1 ||
    x.ItemDescription.toLowerCase().indexOf(
      poDetailsGridInstance._options._optionManager._options.searchPanel.text.toLowerCase()
    ) !== -1
  );
};

export default {
  props: {},
  mixins: [BaseViewMixin],
  components: {},
  watch: {
    $route: {
      immediate: true,
      handler: "handleTabRouteChange",
    },
  },
  async created() {
    this.loadPoDetails();
  },
  updated() {
    if (this.dataLoaded) {
      validationEngine.validateGroup(this.formsConfig.validationGroup);
      validationEngine.validateGroup("toolbarForm");
    }
  },
  data() {
    return {
      gridExpanded: false,
      formHeight: 0,
      toolbarHeight: 0,
      dataLoaded: false,
      visibleEditDeliveryAddress: false,
      poDetailsGridInstance: poDetailsGridInstance,
      poDetailsGridColumns: [],
      poDetailsLineContextMenu: {
        icon: "overflow",
      },
      isCopiedOrder: false,
      brokenGridValidations: [],
      purchaseOrderDetailsDataSourceConfig: [],
      purchaseOrderDetailsReviewList: poDetailsReviewListDataSource,
      orderNotesDataSourceConfig: [],
      contextMenuItems: [
        "Order Comments",
        "Order Notes",
        "Copy Purchase Order",
      ],
      isContextMenuVisible: false,
      commentsPopupVisible: false,
      lineCommentsPopupVisible: false,
      gridRefName: "gridManifestOrder",
      poDetailsGridRefName: "poDetailsGrid",
      poDetailsCurrentView: "Review",
      revertSelection: false,
      toolbar: {
        edit: {
          icon: "edit",
          onClick: () => {
            reviewModeSearchText =
              poDetailsGridInstance._options._optionManager._options.searchPanel
                .text;
            this.$router.push({
              path: `/purchase-order/edit/${this.model.Code}/${
                this.selectedIndex == 0 ? "header" : "details"
              }`,
            });
          },
        },
        save: {
          icon: "floppy",
          validationGroup: "formsData",
          onClick: () => {
            this.$logger.trackEventButtonClickSave();
            this.savePurchaseOrder();
          },
        },
        notes: {
          icon: "file",
          onClick: () => {
            this.commentsPopupVisible = true;
            this.$logger.trackEventOpenPopup("Purchase Order Comments");
          },
        },
        status: {
          icon: "more",
          class: "gc-dropdown-icon-button",
          stylingMode: "text",
          showArrowIcon: false,
          items: ["Account Status"],
          dropDownOptions: { width: 150 },
          onItemClick: () => {
            this.popupVisible = true;
          },
        },
        copy: {
          icon: "copy",
          validationGroup: "formsData",
          onClick: async () => {
            let confirmLeaving = await this.$confirm(
              "Do you want to copy the Purchase Order ?",
              "Copy Purchase Order"
            );

            if (confirmLeaving) {
              this.model.NextStatus = this.getFactorByCode(547).Factorc;
              this.model.DateIn = new Date();
              this.model.Status = "D";
              this.model.Code = 0;
              this.model.GoodsIn = false;
              this.model.Status = "A";
              this.isCopiedOrder = true;

              poDetailsReviewListDataSource.items().forEach((item) => {
                ProductPurchaseService.getBySupplierAndCode(
                  item.ItemCode,
                  this.model.SupplierName
                ).then((response) => {
                  let SupplierLeadValue = response.data.value[0].SupplierLead;
                  let defaultRequiredByDate = new Date();
                  defaultRequiredByDate.setDate(
                    defaultRequiredByDate.getDate() + SupplierLeadValue
                  );
                  item.RequiredByDate = defaultRequiredByDate;
                  item.ETADate = defaultRequiredByDate;
                });
              });
              poDetailsReviewListDataSource.items().forEach((item) => {
                item.SupplierReceivedQty = 0;
                item.ReceivedQty = 0;
                item.LineStatus = "A";
              });

              poDetailsGlChartDataSource.items().forEach((item) => {
                item.RequiredByDate = new Date();
                item.ETADate = new Date();
              });

              this.$router.push({
                path: `/purchase-order/create`,
              });

              this.$logger.trackEventButtonClick(`Purchase Order Copy`);
            }
          },
        },
        audit: {
          icon: "clock",
          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      columns: [
        {
          caption: "Note",
          dataField: "Note",
          sortOrder: "desc",
          width: 400,
          alignment: "left",
          cellTemplate: "note-template",
          editorOptions: {
            maxLength: 1000,
          },
          validationRules: [
            {
              type: "required",
              message: "Note is required",
            },
          ],
        },
      ],
      commentItems: [
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "DeliveryInstruction1",
              label: { text: "Delivery 1" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
            },
            {
              dataField: "DeliveryInstruction2",
              label: { text: "Delivery 2" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
            },
            {
              dataField: "Comment1",
              label: { text: "Comment 1" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
            },
            {
              dataField: "Comment2",
              label: { text: "Comment 2" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
            },
            {
              dataField: "Comment3",
              label: { text: "Comment 3" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
            },
            {
              dataField: "Comment4",
              label: { text: "Comment 4" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
            },
            {
              dataField: "Comment5",
              label: { text: "Comment 5" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
            },
          ],
        },
      ],
      lineCommentItems: [
        {
          dataField: "Comment",
          editorType: "dxTextArea",
          editorOptions: {
            format: this.getDecimalFormatByCode(6).Format,
            height: 70,
            maxLength: 100,
          },
          validationRules: [],
          label: {
            text: " ",
            location: "top",
          },
        },
      ],
      lineCommentModel: {
        Comment: "",
        IsCommentVisible: false,
      },
      model: {
        ContainsManualBatch: false,
        Authorised1: "",
        Authorised2: "",
        AuthorisedBy: "",
        AutoGenerated: "",
        B2BSupplierReferenceNo: "",
        ChangedBy: "",
        Code: "",
        Comment1: "",
        Comment2: "",
        Comment3: "",
        Comment4: "",
        Comment5: "",
        Confirmed: "",
        CreatedBy: "",
        CurrencyCode: "",
        DateAuthorised: "",
        DateIn: "",
        DateInto: null,
        DeliveryAddressCompanyName: null,
        DeliveryAddressCountry: null,
        DeliveryAddressPostcode: "",
        DeliveryAddressState: "",
        DeliveryAddressStreetLine1: "",
        DeliveryAddressStreetLine2: "",
        DeliveryAddressSuburb: "",
        DeliveryInstruction1: "",
        DeliveryInstruction2: "",
        DeliveryMonth: "",
        ExchangeRate: "",
        GoodsReceived: false,
        Name: "",
        NextStatus: "",
        Note: "",
        ProcessStatus: "",
        RecordId: "",
        Status: "",
        SupplierCode: "",
        SupplierName: undefined,
        View: "",
        GoodsIn: false,
        Supplier: {
          Code: "",
          CurrencyCode: "",
          Fax1: "",
          InternationalFax: "",
          InternationalPhone: "",
          MailAddressCountry: "",
          MailAddressPostcode: "",
          MailAddressState: "",
          MailAddressStreetLine1: "",
          MailAddressStreetLine2: "",
          MailAddressSuburb: "",
          Name: "",
          Phone1: "",
          PhysicalAddressCountry: "",
          PhysicalAddressPostcode: "",
          PhysicalAddressState: "",
          PhysicalAddressStreetLine1: "",
          PhysicalAddressStreetLine2: "",
          PhysicalAddressSuburb: "",
          Status: "",
          SupplierTypeCode: "",
          WithholdingTaxRate: "",
        },
        CompanyCurrency: "",
      },
      popupVisible: false,
      totalOutstanding: 0,
      DateChanged: "",
      DateCreated: "",
      ChangedBy: "",
      CreatedBy: "",
    };
  },
  computed: {
    noDataMessage() {
      let noDataMessageObject = {
        addNew: {},
      };

      if (this.poDetailsCurrentView == "Review") {
        noDataMessageObject.addNew = {
          class: "add-new",
          title: "No Order Lines",
          message: "Get Started, Add a PO Line",
        };
      } else if (this.poDetailsCurrentView == "ProductList") {
        let customMessage = "Products will show when a Supplier is selected.";

        if (this.model.SupplierName) {
          customMessage =
            "Products will show if the Supplier is a supplier of the product.  Head over to the Product screen to nominate the suppiler of the product.";
        }

        noDataMessageObject.addNew = {
          class: "no-data",
          title: "No Product Lines",
          message: customMessage,
        };
      } else if (this.poDetailsCurrentView == "GeneralLedger") {
        noDataMessageObject.addNew = {
          class: "no-data",
          title: "No Order Lines",
          message:
            "GL Accounts must be inthe system for them to appear here.  Head over to the GL Chart screen to start adding them.",
        };
      } else {
        noDataMessageObject.addNew = {
          class: "add-new",
          title: "No Order Lines",
          message: "Get Started, Add a PO Line",
        };
      }

      return noDataMessageObject;
    },
    setGridHeight() {
      if (!this.gridExpanded) {
        return this.gridHeight - (this.formHeight + this.toolbarHeight);
      } else {
        return this.gridHeight - this.toolbarHeight;
      }
    },
    deliveryAddressFormItems() {
      let items = this.parseFormColumns([
        {
          dataField: "DeliveryAddressCompanyName",
          gcLabel: "Firm",
          gcType: "String",
          editorOptions: {
            maxLength: "100",
            readOnly:
              this.model.Status === "C" ||
              this.model.Status === "X" ||
              (this.model.Status === "A" && this.model.GoodsIn),
          },
          editorType: "dxTextBox",
        },
        {
          dataField: "DeliveryAddressStreetLine1",
          gcLabel: "Street Line 1",
          gcType: "String",
          editorOptions: {
            maxLength: "50",
            readOnly:
              this.model.Status === "C" ||
              this.model.Status === "X" ||
              (this.model.Status === "A" && this.model.GoodsIn),
          },
          editorType: "dxTextBox",
        },
        {
          dataField: "DeliveryAddressStreetLine2",
          gcLabel: "Street Line 2",
          gcType: "String",
          editorOptions: {
            maxLength: "50",
            readOnly:
              this.model.Status === "C" ||
              this.model.Status === "X" ||
              (this.model.Status === "A" && this.model.GoodsIn),
          },
          editorType: "dxTextBox",
        },
        {
          dataField: "DeliveryAddressSuburb",
          gcLabel: "Suburb",
          gcType: "String",
          editorOptions: {
            maxLength: "50",
            readOnly:
              this.model.Status === "C" ||
              this.model.Status === "X" ||
              (this.model.Status === "A" && this.model.GoodsIn),
          },
          editorType: "dxTextBox",
        },
        {
          dataField: "DeliveryAddressState",
          gcLabel: "State",
          gcType: "String",
          editorOptions: {
            maxLength: "50",
            readOnly:
              this.model.Status === "C" ||
              this.model.Status === "X" ||
              (this.model.Status === "A" && this.model.GoodsIn),
          },
          editorType: "dxTextBox",
        },
        {
          dataField: "DeliveryAddressPostcode",
          gcLabel: "Post Code",
          gcType: "String",
          editorOptions: {
            maxLength: "50",
            readOnly:
              this.model.Status === "C" ||
              this.model.Status === "X" ||
              (this.model.Status === "A" && this.model.GoodsIn),
          },
          editorType: "dxTextBox",
        },
        {
          dataField: "DeliveryAddressCountry",
          gcLabel: "Country",
          gcType: "String",
          editorOptions: {
            maxLength: "50",
            readOnly:
              this.model.Status === "C" ||
              this.model.Status === "X" ||
              (this.model.Status === "A" && this.model.GoodsIn),
          },
          editorType: "dxTextBox",
        },
      ]);

      return items;
    },
    gridColumns() {
      return this.parseGridColumns("transaction-editable", [
        {
          gcLabel: "Item",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          dataField: this.itemDescriptionDataField,
          cellTemplate: "primaryImageTemplate",
          gcExport: ["ItemCode", "ItemDescription"],
        },
        {
          gcLabel: "Code",
          dataField: this.itemCodeDataField,
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Description",
          dataField: this.itemDescriptionDataField,
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },

        {
          gcLabel: "Branch Code",
          dataField: "BranchCode",
          allowFiltering: false,
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },

        {
          gcLabel: "Branch Description",
          dataField: "BranchDescription",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
          allowFiltering: false,
        },

        {
          gcLabel: "Branch",
          dataField: "BranchCode",
          gcType: "String",
          width: 200,
          allowFixing: true,
          allowFiltering: false,
          fixedPosition: "left",
          fixed: true,
          allowEditing:
            this.baseView.mode != "review" &&
            !(this.model.Status === "C" || this.model.Status === "X"),
          cssClass: this.editorCell,
          validationRules: [
            {
              type: "custom",
              message: "Branch is required",
              validationCallback: this.branchValidator,
            },
          ],
          cellTemplate: "branch-template",
          editCellTemplate: "branchEditTemplate",
        },

        {
          gcLabel: "Division",
          dataField: "DivisionCode",
          allowFiltering: false,
          gcType: "String",
          allowSorting: false,
          width: 200,
          allowFixing: true,
          fixedPosition: "left",
          fixed: true,
          allowEditing:
            this.baseView.mode != "review" &&
            !(this.model.Status === "C" || this.model.Status === "X"),

          cssClass: this.editorCell,

          validationRules: [
            {
              type: "custom",
              message: "Division is required",
              validationCallback: this.branchValidator,
            },
          ],
          cellTemplate: "division-template",
          editCellTemplate: "divisionEditTemplate",
        },

        {
          gcLabel: "Division Code",
          dataField: "DivisionCode",
          allowFiltering: false,
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },

        {
          gcLabel: "Division Description",
          dataField: "DivisionDescription",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
          allowFiltering: false,
        },

        {
          gcLabel: "Line No",
          dataField: "LineNo",
          gcType: "String",
          width: 100,
          fixed: true,
          visible: false,
          fixedPosition: "left",
          allowFiltering: false,
        },
        {
          gcLabel: "Required By",
          dataField: "RequiredByDate",
          cssClass: this.editorCell,
          editCellTemplate: "requiredByEditTemplate",
          gcType: "Date",
          allowEditing: true,
          showEditorAlways: true,
        },

        {
          gcLabel: "ETA",
          cssClass: this.editorCell,
          dataField: "ETADate",
          editCellTemplate: "etaEditTemplate",
          gcType: "Date",
          allowEditing: true,
          showEditorAlways: true,
        },

        {
          gcLabel: "UM",
          dataField: "SupplierUM",
          gcType: "String",
          width: 100,
        },

        {
          gcLabel: "Quantity",
          dataField: "SupplierRequired",
          cssClass: this.editorCell,
          editCellTemplate: "qtyEditTemplate",
          cellTemplate: "qtyEditTemplate2",
          gcType: "Decimal-6-2",
          allowFiltering: false,
        },

        {
          gcLabel: "Received",
          dataField: "SupplierReceivedQty",
          gcType: "Decimal-6-2",
          allowFiltering: false,
        },

        {
          gcDynamicLabel: `Price(${this.model.CurrencyCode})`,
          dataField: "SupplierFXPrice",
          cellTemplate: "priceEditTemplate",
          editCellTemplate: "priceEditTemplate",

          gcType: "Decimal-6-2",
          cssClass: "gc-editor-cell",
          allowFiltering: false,
        },

        {
          gcDynamicLabel: `Total(${this.model.CurrencyCode})`,
          dataField: "FXLineTotal",
          gcType: "Decimal-6-2",
          allowFiltering: false,
        },
        {
          gcLabel: "",
          gcType: "String",
          gcSubType: "IconButton",
          cssClass: "more-menu",
          cellTemplate: "menu-cell-template",
        },
      ]);
    },

    itemCodeDataField() {
      let field = "";
      if (this.poDetailsCurrentView === "Review") field = "ItemCode";
      else if (this.poDetailsCurrentView === "ProductList")
        field = "ProductCode";
      else if (this.poDetailsCurrentView === "GeneralLedger") field = "Code";
      return field;
    },

    itemDescriptionDataField() {
      let field = "";
      if (this.poDetailsCurrentView === "Review") field = "ItemDescription";
      else if (this.poDetailsCurrentView === "ProductList")
        field = "ProductDescription1";
      else if (this.poDetailsCurrentView === "GeneralLedger")
        field = "Description";
      return field;
    },

    editorCell() {
      return this.baseView.mode != "review" &&
        !(this.model.Status === "C" || this.model.Status === "X")
        ? "gc-editor-cell"
        : "";
    },
    isEditVisible() {
      return this.model.Status !== "C" && this.model.Status !== "X";
    },
    deleteEnabled() {
      return this.baseView.mode != "review";
    },
    ...mapGetters({ applicationMode: "profile/applicationMode" }),
    tabs() {
      return [
        {
          text: "Header",
          path: `/purchase-order/${this.baseView.mode}/${this.baseView.id}/header`,
        },
        {
          text: "Details",
          path: `/purchase-order/${this.baseView.mode}/${this.baseView.id}/details`,
        },
      ];
    },
    fields() {
      return {
        dateBoxOptions: {
          invalidDateMessage:
            "The date must have the following format: MM/dd/yyyy",
        },
        deliverToOptions: { height: 140 },
      };
    },
    dataSourceConfig() {
      return SalesOrderNoteService.dataSourceConfig({
        select: ["Note", "LineNo", "SalesOrderCode"],
        // sort: [{ selector: "LineNo", asc: true }],
        filter: ["SalesOrderCode", "=", this.model.Code],
      });
    },

    statusFreindly() {
      let status =
        this.model.Status == "" ? "D" : this.model.Status.toUpperCase();
      if (status !== "X" && this.model.Status !== "C") {
        if (
          this.model.IsLockedForPicking !== undefined &&
          this.model.IsLockedForPicking.toUpperCase() === "Y"
        ) {
          status = "L";
        }
      }

      return status;
    },
    headerFormItems() {
      let items = [
        {
          itemType: "group",
          caption: "",
          colCount: 3,
          items: [
            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: "DateIn",
                  gcLabel: "Date In",
                  gcType: "Date",
                  required: true,
                },
                {
                  dataField: "NextStatus",
                  gcLabel: "Next Status",
                  gcType: "String",
                  editorType: "dxSelectBox",
                  required: true,
                  editorOptions: {
                    readOnly:
                      this.model.Status === "C" || this.model.Status === "X",
                    items: this.getNextStatus,
                    valueExpr: "id",
                    displayExpr: "text",
                  },
                },
              ]),
            },
            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: "CurrencyCode",
                  gcLabel: "Currency",
                  gcType: "String",
                  editorType: "dxTextBox",
                  readOnly: true,
                },
                {
                  dataField: "ExchangeRate",
                  gcType: "Decimal-6-4",
                  gcLabel: "Exchange Rate",
                  editorOptions: {
                    readOnly:
                      this.model.CompanyCurrency === this.model.CurrencyCode ||
                      this.model.Status === "C" ||
                      this.model.Status === "X" ||
                      this.model.GoodsIn,
                  },
                },
              ]),
            },
            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: "DeliveryAddressCompanyName",
                  gcLabel: "Deliver To",
                  gcType: "String",
                  editorType: "dxTextBox",
                  editorOptions: {
                    maxLength: "100",
                    readOnly:
                      this.model.Status === "C" ||
                      this.model.Status === "X" ||
                      (this.model.Status === "A" && this.model.GoodsIn),
                  },
                },
                {
                  dataField: "",
                  template: "editAddressTemplate",
                  gcType: "Button",
                },
              ]),
            },
          ],
        },
      ];

      return items;
    },
    getNextStatus() {
      let items = [];
      if (this.model.Status == "N") {
        items = [
          { text: "Draft", id: "D" },
          { text: "Pending", id: "P" },
          { text: "Active", id: "A" },
        ];
      } else if (this.model.Status == "D" || this.model.Status == "P") {
        items = [
          { text: "Draft", id: "D" },
          { text: "Pending", id: "P" },
          { text: "Active", id: "A" },
          { text: "Cancelled", id: "X" },
        ];
      } else if (this.model.Status == "A") {
        if (this.model.GoodsIn) {
          items = [
            { text: "Active", id: "A" },
            { text: "Completed", id: "C" },
            { text: "Cancelled", id: "X" },
          ];
        } else {
          items = [
            { text: "Draft", id: "D" },
            { text: "Pending", id: "P" },
            { text: "Active", id: "A" },
            { text: "Cancelled", id: "X" },
            { text: "Completed", id: "C" },
          ];
        }
      }
      return items;
    },

    poDetailsGrid() {
      return this.$refs[this.poDetailsGridRefName]
        ? this.$refs[this.poDetailsGridRefName].instance
        : null;
    },
    poDetailsColumnTotalLabel() {
      return `Total (${this.model.CurrencyCode})`;
    },
    poDetailsColumnPriceLabel() {
      return `Price (${this.model.CurrencyCode})`;
    },
    computedExTaxTotal() {
      let total = 0;
      if (this.purchaseOrderDetailsReviewList)
        this.purchaseOrderDetailsReviewList
          .items()
          .forEach(
            (x) =>
              (total +=
                parseFloat(x.SupplierRequired).roundNumber(4) *
                parseFloat(x.SupplierFXPrice).roundNumber(4))
          );

      return total;
    },
    computedTaxTotal() {
      let total = 0;
      if (this.purchaseOrderDetailsReviewList)
        this.purchaseOrderDetailsReviewList
          .items()
          .forEach(
            (x) =>
              (total +=
                parseFloat(x.FXLineTotal).roundNumber(4) *
                parseFloat(x.TaxPcnt).roundNumber(4) *
                0.01)
          );

      return total.roundNumber(4);
    },
    computedItemCount() {
      let total = 0;

      if (this.purchaseOrderDetailsReviewList)
        this.purchaseOrderDetailsReviewList
          .items()

          .forEach(
            (x) => (total += parseFloat(x.SupplierRequired).roundNumber(4))
          );

      return total;
    },
    computedTotal() {
      return this.computedTaxTotal + this.computedExTaxTotal;
    },
    toolbarFormItems() {
      var items = [
        {
          dataField: "SupplierName",
          ref: "supplierCode",
          cssClass: "toolbar-customer-label",
          validationRules: [
            {
              type: "required",
              message: "Supplier is required",
            },
          ],
          editorType: "dxSelectBox",

          editorOptions: {
            dataSource: AgentSupplierService.dataSourceConfig("api/Supplier", {
              sort: [{ selector: "Name", asc: true }],
              top: 5,
              filter: ["Inactive", "=", "N"],
            }),
            width: 300,
            valueExpr: "Code",
            displayExpr: "Name",
            searchExpr: ["Code", "Name"],
            searchMode: "contains",
            showClearButton: true,
            itemTemplate: "agentTemplate",
            searchEnabled: true,
            dropDownOptions: {
              minWidth: 300,
            },
            placeholder: "Supplier Name",
            onValueChanged: this.onSupplierCodeValueChanged.bind(this),
          },
          label: {
            visible: false,
          },
        },
      ];

      return this.dataLoaded ? items : [];
    },

    toolbarActiveItems() {
      return this.parseFormColumns([
        {
          dataField: "GoodsReceived",
          gcLabel: "Goods Received",
          gcType: "Boolean",
          cssClass: "toolbar-customer-label",
          editorOptions: {
            readOnly:
              this.model.Status == "C" ||
              this.model.Status == "X" ||
              (this.model.Status == "C" && this.model.GoodsIn),
            visible: this.model.NextStatus == "A" ? true : false,
            disabled: this.model.GoodsIn,
          },
        },
      ]);
    },
    toolbarDetailsFormItems() {
      return this.parseFormColumns([
        {
          dataField: "View",
          gcLabel: " ",
          gcType: "String",
          editorType: "dxSelectBox",
          editorOptions: {
            width: 200,
            items: [
              {
                value: "Review",
                text: "Review",
              },
              {
                value: "ProductList",
                text: "Product",
              },
              {
                value: "GeneralLedger",
                text: "General Ledger",
              },
            ],
            displayExpr: "text",
            valueExpr: "value",
            value: this.poDetailsCurrentView,
            onValueChanged: this.detailsViewChanged.bind(this),
          },
        },
      ]);
    },
  },
  methods: {
    onFormContentReady() {
      if (document.getElementsByClassName("purchase-order-form").length != 0) {
        this.formHeight = document.getElementsByClassName(
          "purchase-order-form"
        )[0].clientHeight;
        this.toolbarHeight = document.getElementsByClassName(
          "purchase-order-toolbar"
        )[0].clientHeight;
      }
    },
    expandGrid() {
      this.gridExpanded = !this.gridExpanded;
      this.$refs[this.poDetailsGridRefName].instance.repaint(true);
    },
    editDeliveryAddress() {
      this.visibleEditDeliveryAddress = !this.visibleEditDeliveryAddress;
    },
    deliveryAddressCallBack() {
      this.visibleEditDeliveryAddress = false;
    },
    onQuantityChanged(valueChangedEventArg, cellInfo) {
      currentRowIndex = cellInfo.rowIndex;
      cellInfo.data.SupplierRequired = valueChangedEventArg.value;

      if (valueChangedEventArg.value == 0) {
        cellInfo.data.SupplierFXPrice = 0;
        cellInfo.data.FXLineTotal = 0;
        if (this.poDetailsCurrentView == "ProductList") {
          // this.setLineTotal(currentRowIndex);
          const index = poDetailsReviewListDataSource
            .items()
            .findIndex((x) => x.ItemCode === cellInfo.data.Code);
          if (index > -1 && !this.model.GoodsIn) {
            poDetailsReviewListDataSource.items().splice(index, 1);
          }
        } else if (this.poDetailsCurrentView == "GeneralLedger") {
          // this.setLineTotal(currentRowIndex);
          const index = poDetailsReviewListDataSource
            .items()
            .findIndex((x) => x.Code === cellInfo.data.Code);
          if (
            (index > -1 && !this.model.GoodsIn) ||
            (index > -1 && this.isCopiedOrder)
          ) {
            poDetailsReviewListDataSource.items().splice(index, 1);
          }
        } else if (this.poDetailsCurrentView == "Review") {
          cellInfo.data.SupplierRequired = valueChangedEventArg.value;

          // this.setLineTotal(currentRowIndex);
          const index = poDetailsReviewListDataSource
            .items()
            .findIndex((x) => x.Code === cellInfo.data.Code);
          if (
            (index > -1 && !this.model.GoodsIn) ||
            (index > -1 && this.isCopiedOrder)
          ) {
            poDetailsReviewListDataSource.items().splice(index, 1);
          }
        }
      } else {
        if (cellInfo.data.SupplierReceivedQty > valueChangedEventArg.value) {
          let msgObj = {
            Code: cellInfo.data.Code,
            Description: cellInfo.data.Description,
            RequiredQty: valueChangedEventArg.value,
            ReceivedQty: cellInfo.data.SupplierReceivedQty,
          };
          const index = this.brokenGridValidations.findIndex(
            (x) => x.Code === cellInfo.data.Code
          );
          if (index > -1) {
            this.brokenGridValidations[index] = msgObj;
          } else {
            this.brokenGridValidations.push(msgObj);
          }
          this.$nextTick(function () {
            alert(
              `Item : ${
                cellInfo.data.ItemDescription
              } has a required quantity of ${this.formatNumber(
                valueChangedEventArg.value
              )} which is below the received quantity of ${this.formatNumber(
                cellInfo.data.SupplierReceivedQty
              )}.`,

              "Validation Errors"
            );
          });
        } else {
          const index = this.brokenGridValidations.findIndex(
            (x) => x.Code === cellInfo.data.Code
          );
          if (index > -1) {
            this.brokenGridValidations.splice(index, 1);
          }
        }

        // cellInfo.data.IsNewLine = true;

        this.mergeItemWithReviewList(cellInfo.data, cellInfo.column.dataField);
      }
    },

    setLineNo() {
      const maxLineNo = Math.max.apply(
        Math,
        poDetailsReviewListDataSource.items().map(function (o) {
          return o.LineNo;
        })
      );

      poDetailsReviewListDataSource.items()[
        poDetailsReviewListDataSource.items().length - 1
      ].LineNo = maxLineNo + 1;
      poDetailsReviewListDataSource.items()[
        poDetailsReviewListDataSource.items().length - 1
      ].isNewRecord = true;
    },

    onPriceChanged(valueChangedEventArg, cellInfo) {
      // currentRowIndex = cellInfo.rowIndex;

      // this.updateDataSource(
      //   this.getCurrentPoDetailsDataSource(),
      //   currentRowIndex,
      //   cellInfo.column.dataField,
      //   valueChangedEventArg.value
      // );

      cellInfo.data.FXLineTotal =
        cellInfo.data.SupplierRequired * valueChangedEventArg.value;

      cellInfo.data[cellInfo.column.dataField] = valueChangedEventArg.value;

      // poDetailsGridInstance.cellValue(
      //   currentRowIndex,
      //   "FXLineTotal",
      //   this.getCurrentPoDetailsDataSource().items()[currentRowIndex]
      //     .FXLineTotal
      // );
    },
    onDateChanged(valueChangedEventArg, cellInfo) {
      currentRowIndex = cellInfo.rowIndex;
      cellInfo.data[cellInfo.column.dataField] = valueChangedEventArg.value;
    },
    getBranchDataSource() {
      return BranchService.dataSourceConfig("api/Branch", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Description", asc: false }],
      });
    },
    getDivisionDataSource() {
      return DivisionService.dataSourceConfig("api/Division", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Description", asc: false }],
      });
    },

    formatNumber(number) {
      return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },
    async onBranchChanged(valueChangedEventArg, cellInfo) {
      currentRowIndex = cellInfo.rowIndex;

      cellInfo.data[cellInfo.column.dataField] = valueChangedEventArg.value;

      let res = await BranchService.getByCode(valueChangedEventArg.value);
      let branchDescription = res.data.value[0].Description;

      cellInfo.data.BranchDescription = branchDescription;
    },
    async onDivisionChanged(valueChangedEventArg, cellInfo) {
      currentRowIndex = cellInfo.rowIndex;

      cellInfo.data[cellInfo.column.dataField] = valueChangedEventArg.value;

      let res = await DivisionService.getByCode(valueChangedEventArg.value);
      let divisionDescription = res.data.value[0].Description;

      cellInfo.data.DivisionDescription = divisionDescription;
    },
    async loadPoDetails() {
      this.showLoading(true);
      reviewModeSearchText = "";

      // let that = this;

      if (this.poDetailsGrid) this.poDetailsGrid.clearFilter("search");
      await this.$store.dispatch(
        "screenFactors/getFactors",
        [616, 549, 550, 505, 95, 87, 565, 547, 18, 65, 66]
      );

      poGlobalModel.DefaultBranchCode = this.getFactorByCode(65).Factorc;
      poGlobalModel.DefaultDivisionCode = this.getFactorByCode(66).Factorc;

      let resBranch = await BranchService.getByCode(
        poGlobalModel.DefaultBranchCode
      );
      poGlobalModel.DefaultBranchDescription =
        resBranch.data.value[0].Description;

      let resDivision = await DivisionService.getByCode(
        poGlobalModel.DefaultDivisionCode
      );
      poGlobalModel.DefaultDivisionDescription =
        resDivision.data.value[0].Description;

      if (this.baseView.mode !== "create") {
        this.model.View = "Review";
        this.model.Code = this.baseView.id;
        await this.getRecord().then((response) => {
          if (response.data.value.length > 0) {
            if (
              response.data.value[0].Status == "D" &&
              this.baseView.mode !== "edit"
            ) {
              // force push screen to edit mode when the Sales Order is in Draft mode
              this.$router.push({
                path: `/purchase-order/edit/${this.model.Code}/${
                  this.selectedIndex == 0 ? "header" : "details"
                }`,
              });
              this.refreshView();
            }

            this.model.Authorised1 = response.data.value[0].Authorised1;
            this.model.Authorised2 = response.data.value[0].Authorised2;
            this.model.AuthorisedBy = response.data.value[0].AuthorisedBy;
            this.model.AutoGenerated = response.data.value[0].AutoGenerated;
            this.model.B2BSupplierReferenceNo =
              response.data.value[0].B2BSupplierReferenceNo;
            this.model.ChangedBy = response.data.value[0].ChangedBy;

            this.model.Code = response.data.value[0].Code;
            this.model.Name = `Purchase Order # ${this.model.Code}`;
            this.model.Comment1 = response.data.value[0].Comment1;
            this.model.Comment2 = response.data.value[0].Comment2;
            this.model.Comment3 = response.data.value[0].Comment3;
            this.model.Comment4 = response.data.value[0].Comment4;
            this.model.Comment5 = response.data.value[0].Comment5;
            this.model.Confirmed = response.data.value[0].Confirmed;
            this.model.CreatedBy = response.data.value[0].CreatedBy;
            this.model.CurrencyCode = response.data.value[0].CurrencyCode;
            this.model.DateAuthorised = response.data.value[0].DateAuthorised;
            this.model.DateIn = new Date(response.data.value[0].DateIn);
            this.model.DateInto = new Date(response.data.value[0].DateInto);
            this.model.DeliveryAddressCompanyName =
              response.data.value[0].DeliveryAddressCompanyName;
            this.model.DeliveryAddressCountry =
              response.data.value[0].DeliveryAddressCountry;
            this.model.DeliveryAddressPostcode =
              response.data.value[0].DeliveryAddressPostcode;
            this.model.DeliveryAddressState =
              response.data.value[0].DeliveryAddressState;
            this.model.DeliveryAddressStreetLine1 =
              response.data.value[0].DeliveryAddressStreetLine1;
            this.model.DeliveryAddressStreetLine2 =
              response.data.value[0].DeliveryAddressStreetLine2;
            this.model.DeliveryAddressSuburb =
              response.data.value[0].DeliveryAddressSuburb;
            this.model.DeliveryInstruction1 =
              response.data.value[0].DeliveryInstruction1;
            this.model.DeliveryInstruction2 =
              response.data.value[0].DeliveryInstruction2;
            this.model.DeliveryMonth = response.data.value[0].DeliveryMonth;
            this.model.ExchangeRate = response.data.value[0].ExchangeRate;
            this.model.Note = response.data.value[0].Note;
            this.model.ProcessStatus = response.data.value[0].ProcessStatus;
            this.model.Status = response.data.value[0].Status;
            this.model.SupplierCode = response.data.value[0].SupplierCode;

            this.model.Supplier.Code = response.data.value[0].Supplier.Code;
            this.model.Supplier.CurrencyCode =
              response.data.value[0].Supplier.CurrencyCode;
            this.model.Supplier.Fax1 = response.data.value[0].Supplier.Fax1;
            this.model.Supplier.InternationalFax =
              response.data.value[0].Supplier.InternationalFax;
            this.model.Supplier.InternationalPhone =
              response.data.value[0].Supplier.InternationalPhone;
            this.model.Supplier.MailAddressCountry =
              response.data.value[0].Supplier.MailAddressCountry;
            this.model.Supplier.MailAddressPostcode =
              response.data.value[0].Supplier.MailAddressPostcode;
            this.model.Supplier.MailAddressState =
              response.data.value[0].Supplier.MailAddressState;
            this.model.Supplier.MailAddressStreetLine1 =
              response.data.value[0].Supplier.MailAddressStreetLine1;
            this.model.Supplier.MailAddressStreetLine2 =
              response.data.value[0].Supplier.MailAddressStreetLine2;
            this.model.Supplier.MailAddressSuburb =
              response.data.value[0].Supplier.MailAddressSuburb;
            this.model.SupplierName = response.data.value[0].Supplier.Code;
            this.model.Supplier.Name = response.data.value[0].Supplier.Name;
            this.model.Supplier.Phone1 = response.data.value[0].Supplier.Phone1;
            this.model.Supplier.PhysicalAddressCountry =
              response.data.value[0].Supplier.PhysicalAddressCountry;
            this.model.Supplier.PhysicalAddressPostcode =
              response.data.value[0].Supplier.PhysicalAddressPostcode;
            this.model.Supplier.PhysicalAddressState =
              response.data.value[0].Supplier.PhysicalAddressState;
            this.model.Supplier.PhysicalAddressStreetLine1 =
              response.data.value[0].Supplier.PhysicalAddressStreetLine1;
            this.model.Supplier.PhysicalAddressStreetLine2 =
              response.data.value[0].Supplier.PhysicalAddressStreetLine2;
            this.model.Supplier.PhysicalAddressSuburb =
              response.data.value[0].Supplier.PhysicalAddressSuburb;
            this.model.Supplier.Status = response.data.value[0].Supplier.Status;
            this.model.Supplier.SupplierTypeCode =
              response.data.value[0].Supplier.SupplierTypeCode;
            this.model.Supplier.WithholdingTaxRate =
              response.data.value[0].Supplier.WithholdingTaxRate;
            this.model.NextStatus = this.getFactorByCode(547).Factorc;
            this.model.DateChanged = response.data.value[0].DateChanged;
            this.model.DateCreated = response.data.value[0].DateCreated;
            this.model.ChangedBy = response.data.value[0].ChangedBy;
            this.model.CreatedBy = response.data.value[0].CreatedBy;

            // that.refreshView();

            poDetailsProductListDataSource.filter([
              ["SupplierCode", "=", this.model.SupplierName],
            ]);
          }
        });
        await this.getDetailRecord().then((response) => {
          if (response.data.value.length > 0) {
            response.data.value.forEach((item) => {
              if (item.SupplierReceivedQty > 0) this.model.GoodsIn = true;
            });
          }
        });

        await CompanyService.getByCompanyCode(
          this.getFactorByCode(18).Factorc
        ).then((res) => {
          // this.model.DeliveryAddressCompanyName = res.data.value[0].Name;
          this.model.CompanyCurrency = res.data.value[0].CurrencyCode;
        });

        poDetailsReviewListDataSource.filter([
          ["PurchaseOrderCode", "=", parseInt(this.baseView.id)],
        ]);
        poDetailsGlChartDataSource.filter([["Inactive", "=", "N"]]);
        poDetailsReviewListDataSource.load().then(() => {
          this.purchaseOrderDetailsDataSourceConfig =
            poDetailsReviewListDataSource.items();
        });
        // let grid = this.$refs[this.poDetailsGridRefName].instance;

        // grid.repaint();

        this.showLoading(false);
        this.dataLoaded = true;
      } else if (this.baseView.mode == "create") {
        this.poDetailsCurrentView = "Review";

        this.model.NextStatus = this.getFactorByCode(547).Factorc;
        this.model.DateIn = new Date();
        this.model.Status = "D";
        this.model.Code = 0;

        await CompanyService.getByCompanyCode(
          this.getFactorByCode(18).Factorc
        ).then((res) => {
          this.model.DeliveryAddressCompanyName = res.data.value[0].Name;
          this.model.CompanyCurrency = res.data.value[0].CurrencyCode;
          this.model.CurrencyCode = res.data.value[0].CurrencyCode;
        });

        await BranchService.getByCode(this.getFactorByCode(65).Factorc).then(
          (response) => {
            if (response.data.value.length > 0) {
              this.model.DeliveryAddressStreetLine1 =
                response.data.value[0].PhysicalAddressStreetLine1;
              this.model.DeliveryAddressStreetLine2 =
                response.data.value[0].PhysicalAddressStreetLine2;
              this.model.DeliveryAddressSuburb =
                response.data.value[0].PhysicalAddressSuburb;
              this.model.DeliveryAddressState =
                response.data.value[0].PhysicalAddressState;
              this.model.DeliveryAddressPostcode =
                response.data.value[0].PhysicalAddressPostcode;
              this.model.DeliveryAddressCountry =
                response.data.value[0].PhysicalAddressCountry;
            }
          }
        );

        this.loadDataSources();

        this.model.Name = "Purchase Order";
        this.showLoading(false);
        this.dataLoaded = true;
      }

      this.toolbar.edit.visible = this.formsConfig.editableOption;
    },

    onCellPrepared(e) {
      if (e.rowType === "data" && e.columnIndex == 6) {
        if (e.row.data.LineStatus == "C" || e.row.data.LineStatus == "X")
          e.cellElement.classList.remove("gc-editor-cell");
      } else if (
        e.rowType === "data" &&
        (e.columnIndex == 0 ||
          e.columnIndex == 1 ||
          e.columnIndex == 4 ||
          e.columnIndex == 5 ||
          e.columnIndex == 8)
      ) {
        if (
          e.row.data.LineStatus == "C" ||
          e.row.data.LineStatus == "X" ||
          (e.row.data.LineStatus == "A" && e.row.data.SupplierReceivedQty > 0)
        )
          e.cellElement.classList.remove("gc-editor-cell");
      }
    },
    onPoDetailsLineContextMenuItemClick(e) {
      if (e.itemData.menuText == "Line Comment") {
        let rowData = e.itemData.data.data;

        currentRowIndex = e.itemData.data.component.getRowIndexByKey(
          e.itemData.data.key
        );

        let visibleOnInvoiceFactor = this.getFactorByCode(505);

        this.lineCommentModel.Comment = rowData.Comment;
        this.lineCommentModel.IsCommentVisible =
          rowData.LineNo == 0
            ? visibleOnInvoiceFactor.Factorc == "Y"
              ? true
              : false
            : rowData.IsCommentVisible;

        this.lineCommentsPopupVisible = true;
        this.$logger.trackEventOpenPopup("Purchase Order Line Comment");
        let form = this.$refs["line-comments-form"].instance;
        form.repaint();
      }
    },

    onPoDetailsInitialized(e) {
      poDetailsGridInstance = e.component;
      if (reviewModeSearchText !== "") {
        e.component.searchByText(reviewModeSearchText);
      }
      this.poDetailsGridInstance = e.component;
    },
    onPoDetailsColumnHeaderClick(e) {
      if (e.rowType == "header") {
        poDetailsSortExpr = {
          dataField: e.column.dataField,
          sortOrder: e.column.sortOrder,
        };
      }
    },
    customizeLineCommentItem(item) {
      if (item.itemType == "simple") {
        item.editorOptions = item.editorOptions || {};
        if (item.dataField == "Comment") {
          item.editorOptions.readOnly = this.baseView.mode == "review";
        } else {
          item.editorOptions.disabled = this.baseView.mode == "review";
        }
      }
    },

    async onSupplierCodeValueChanged(e) {
      // this.$logger.debug("e ", e);
      // this.model.View = "ProductList";
      let itemData = e.component.option("items").find((x) => x.Code == e.value);
      // this.$logger.debug("item data ", itemData);
      if (!itemData) {
        poDetailsProductListDataSource.filter(null);
        this.loadPoDetailsProductListDataSource();
        return;
      }

      this.model.Supplier.Phone1 = itemData.Phone1;
      this.model.Supplier.Fax1 = itemData.Fax1;

      this.model.CurrencyCode = itemData.CurrencyCode;
      let result = await CompanyCurrencyService.getByCurrencyCode(
        this.model.CurrencyCode
      );
      this.model.ExchangeRate = result.data.value[0].SellRate;

      poDetailsProductListDataSource.filter([
        "SupplierCode",
        "=",
        this.model.SupplierName,
      ]);

      poDetailsReviewListDataSource.filter([
        "PurchaseOrderCode",
        "=",
        parseInt(this.model.Code),
      ]);

      if (this.model.View != "ProductList") {
        this.model.View = "ProductList";
      } else {
        this.loadPoDetailsProductListDataSource();
        poDetailsReviewListDataSource.load();
      }
    },

    loadPoDetailsProductListDataSource() {
      return poDetailsProductListDataSource.load();
    },
    loadPoDetailsGcChartDataSource() {
      poDetailsGlChartDataSource.filter([["Inactive", "=", "N"]]);
      return poDetailsGlChartDataSource.load();
    },
    loadDataSources() {
      poDetailsReviewListDataSource.filter([
        "PurchaseOrderCode",
        "=",
        parseInt(this.model.Code),
      ]);

      poDetailsGlChartDataSource.filter([["Inactive", "=", "N"]]);

      poDetailsReviewListDataSource.load().then(() => {
        this.purchaseOrderDetailsDataSourceConfig =
          poDetailsReviewListDataSource.items();

        this.loadPoDetailsProductListDataSource().then(() => {
          this.mergeProductListData();
          this.loadPoDetailsGcChartDataSource().then(() => {
            this.mergePoGlChartData();
            if (this.poDetailsCurrentView !== "Review")
              this.purchaseOrderDetailsDataSourceConfig =
                this.getCurrentPoDetailsDataSource();
          });
        });
      });
    },
    mergePoGlChartData() {
      poDetailsReviewListDataSource.items().forEach((details) => {
        var foundIndex = poDetailsGlChartDataSource
          .items()
          .findIndex((item) => item.ItemCode == details.ItemCode);
        if (foundIndex !== -1) {
          poDetailsGlChartDataSource.items()[foundIndex] = details;
        }
      });
    },
    mergeProductListData() {
      poDetailsReviewListDataSource.items().forEach((details) => {
        var foundIndex = poDetailsProductListDataSource
          .items()
          .findIndex((item) => item.ItemCode == details.ItemCode);
        if (foundIndex !== -1) {
          poDetailsProductListDataSource.items()[foundIndex] = details;
        }
      });
    },

    branchValidator(e) {
      if (e.data.SupplierRequired > 0 && e.data.BranchCode == null)
        return false;
      return true;
    },
    customItemCreating(data) {
      if (!data.text) {
        data.customItem = null;
        return;
      }

      const newItem = {
        CompanyName: data.text,
        PhysicalAddressCountry: "",
        PhysicalAddressPostcode: "",
        PhysicalAddressState: "",
        PhysicalAddressStreetLine1: "",
        PhysicalAddressStreetLine2: "",
        PhysicalAddressSuburb: "",
      };

      data.customItem = newItem;
    },
    // end validations
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: "before",
        template: "totalOutstanding",
      });
    },
    onDeleteClick(e) {
      let grid = this.$refs[this.gridRefName].instance;
      let arr = grid.getDataSource().items();
      arr.splice(e.rowIndex, 1);

      this.orderNotesDataSourceConfig = arr;
    },
    onToolbarPreparingPoDetails(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      // var columnChooserButton = toolbarItems.find((item) => {
      //   return item.name === "columnChooserButton";
      // });

      let itemsToRemoveFromToolBar = [
        "searchPanel",
        "revertButton",
        "saveButton",
        // "columnChooserButton",
      ];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name)
      );

      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        searchPanel,
        // columnChooserButton,
        {
          widget: "dxForm",
          location: "before",
          disabled: this.baseView.mode == "review" ? true : false,
          options: {
            formData: this.model,
            items: this.toolbarDetailsFormItems,
            validationGroup: this.formsConfig.validationGroup,
            labelLocation: "left",
          },
          locateinmenu: "auto",
        },
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: this.gridExpanded ? "collapse" : "expand",
            onClick: this.expandGrid,
          },
        }
      );
    },
    mergeItemWithReviewList(currentRow, dataField) {
      if (this.poDetailsCurrentView == "Review") {
        this.updatePoDetailsLineValues(currentRow);

        let foundIndexInGlChart = poDetailsGlChartDataSource
          .items()
          .findIndex((x) => x.ItemCode == currentRow.ItemCode);
        if (foundIndexInGlChart > -1)
          poDetailsGlChartDataSource.items()[foundIndexInGlChart] = currentRow;

        let foundIndexInProductList = poDetailsProductListDataSource
          .items()
          .findIndex((x) => x.ItemCode == currentRow.ItemCode);
        if (foundIndexInProductList > -1)
          poDetailsProductListDataSource.items()[foundIndexInProductList] =
            currentRow;
      }

      if (this.poDetailsCurrentView !== "Review") {
        if (
          !poDetailsReviewListDataSource
            .items()
            .find((x) => x.ItemCode == currentRow.ItemCode)
        ) {
          if (dataField == "SupplierRequired") {
            // if (this.poDetailsCurrentView == "ProductList") {
            //   currentRow.SupplierFXPrice = currentRow.SupplierPrice;
            // }

            this.updatePoDetailsLineValues(currentRow);
          }

          poDetailsReviewListDataSource.items().push(currentRow);
          this.setLineNo();
        } else {
          // if (this.poDetailsCurrentView == "ProductList") {
          //   currentRow.SupplierFXPrice = currentRow.SupplierPrice;
          // }
          this.updatePoDetailsLineValues(currentRow);
        }
      }
    },
    updatePoDetailsLineValues(currentRow) {
      currentRow.RequiredQty =
        currentRow.SupplierRequired * currentRow.SupplierConversion;
      currentRow.SupplierFXPrice = currentRow.SupplierPrice;
      currentRow.FXPrice = currentRow.SupplierFXPrice;
      currentRow.Price = currentRow.FXPrice * this.model.ExchangeRate;
      currentRow.OutstandingQty =
        currentRow.RequiredQty - currentRow.ReceivedQty;
      currentRow.SupplierOutstandingQuantity =
        currentRow.OutstandingQty * currentRow.SupplierConversion;
      currentRow.FXLineTotal =
        currentRow.SupplierRequired * currentRow.SupplierFXPrice;
      currentRow.ExTotal = currentRow.FXPrice * currentRow.RequiredQty;
    },
    getCurrentPoDetailsDataSource() {
      if (this.poDetailsCurrentView == "Review")
        return poDetailsReviewListDataSource;

      if (this.poDetailsCurrentView == "ProductList")
        return poDetailsProductListDataSource;

      if (this.poDetailsCurrentView == "GeneralLedger")
        return poDetailsGlChartDataSource;

      return [];
    },
    updateDataSource(dataSource, index, field, value) {
      dataSource.items()[index][field] = value;
    },

    detailsViewChanged(e) {
      if (this.poDetailsCurrentView == e.value) return;
      this.poDetailsCurrentView = e.value;
      this.loadCurrentViewData();
    },
    loadCurrentViewData() {
      if (this.poDetailsCurrentView == "Review") {
        this.purchaseOrderDetailsDataSourceConfig =
          poDetailsReviewListDataSource.items();
      } else if (this.poDetailsCurrentView == "ProductList") {
        this.purchaseOrderDetailsDataSourceConfig =
          poDetailsProductListDataSource;
      } else if (this.poDetailsCurrentView == "GeneralLedger") {
        this.purchaseOrderDetailsDataSourceConfig = poDetailsGlChartDataSource;
      }

      this.poDetailsGrid && this.poDetailsGrid.refresh();
    },

    async handleTabRouteChange() {
      if (this.baseView.tab === "details") {
        this.selectedIndex = 1;
      } else {
        if (this.selectedIndex != 0) this.selectedIndex = 0;
      }
    },
    async getRecord() {
      return await PurchaseOrder.getByCode(this.baseView.id);
    },

    async getDetailRecord() {
      return await PurchaseOrderDetail.getByCode(this.baseView.id);
    },

    async getFactor(code) {
      return await FactorService.getByCode(code);
    },
    itemClick(e) {
      this.$router.push({
        path: e.itemData.path,
      });
    },

    containsManualBatches() {
      let hasManualBatch = false;

      for (const item of poDetailsReviewListDataSource.items()) {
        if (item.IsBatchProduct === "Manual") {
          hasManualBatch = true;
          break;
        }
      }

      return hasManualBatch;
    },

    async savePurchaseOrder() {
      if (this.containsManualBatches() && this.model.GoodsReceived) {
        this.displayValidationSummary([
          "Items on this Purchase Order have a manual batch method and cannot be received automatically.  Please perform the goods received manually.",
        ]);
      } else {
        this.saveOrder();
      }
    },

    async saveOrder() {
      if (this.brokenGridValidations.length === 0) {
        const mainForm = await validationEngine.validateGroup("formsData");
        const toolbarForm = await validationEngine.validateGroup("toolbarForm");

        var value = mainForm.brokenRules.concat(toolbarForm.brokenRules);

        if (!mainForm.isValid || !toolbarForm.isValid) {
          this.addErrorMessagesFromValidationResult({
            brokenRules: value,
          });
          this.displayCustomValidationSummary();
          return;
        }

        if (!this.getPoSavePayload().PurchaseOrderDetails.length) {
          this.displayValidationSummary([
            "Purchase Order has no detail. Please add one or more lines before attempting to save the transaction again.",
          ]);
          return;
        }
        this.showLoading(true);
        await PurchaseOrder.savePurchaseOrder(
          this.getPoSavePayload(),
          this.model.Code
        )
          .then(async (res) => {
            this.showLoading(false);
            if (this.baseView.mode == "create") {
              this.model.Name = undefined;
              this.model.Code = res.data.Code;
            }
            this.$notify(
              `Purchase Order ${this.model.Code} Successfully Saved`,
              "success"
            );
            let destinationMode =
              res.data.NextStatus == "D" ? "edit" : "review";
            let destinationTab = this.selectedIndex == 0 ? "header" : "details";
            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: `/purchase-order/${destinationMode}/${this.model.Code}/${destinationTab}`,
            });

            await this.loadPoDetails();
          })
          .catch((error) => {
            this.displayServerError(error, "Save purchase order Failed");
          });
      } else {
        let validationMessages = this.brokenGridValidations.map((item) => {
          return `Item : ${
            item.Description
          } has a required quantity of ${this.formatNumber(
            item.RequiredQty
          )} which is below the received quantity of ${this.formatNumber(
            item.ReceivedQty
          )}.`;
        });
        this.displayValidationSummary(validationMessages);
      }
    },

    getPoSavePayload() {
      let payload = {
        Code: this.model.Code,
        DateIn: this.model.DateIn.toSaveDate(),
        GoodsReceived: this.model.GoodsReceived ? "Y" : "N",
        DeliveryAddressCompanyName: this.model.DeliveryAddressCompanyName,
        DeliveryAddressStreetLine1: this.model.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: this.model.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: this.model.DeliveryAddressSuburb,
        DeliveryAddressState: this.model.DeliveryAddressState,
        DeliveryAddressPostcode: this.model.DeliveryAddressPostcode,
        DeliveryAddressCountry: this.model.DeliveryAddressCountry,
        SupplierCode: this.model.SupplierName,
        ExchangeRate: this.model.ExchangeRate,
        DeliveryInstruction1: this.model.DeliveryInstruction1,
        DeliveryInstruction2: this.model.DeliveryInstruction2,
        Comment1: this.model.Comment1,
        Comment2: this.model.Comment2,
        Comment3: this.model.Comment3,
        Comment4: this.model.Comment4,
        Comment5: this.model.Comment5,
        CurrentStatus: this.model.Status,
        NextStatus: this.model.NextStatus,
        PurchaseOrderDetails: [],
      };

      this.purchaseOrderDetailsDataSourceConfig;
      poDetailsReviewListDataSource.items().forEach((data) => {
        let detailObj = {
          BranchCode: data.BranchCode,
          Comment: data.Comment,
          DiscPcnt: data.DiscPcnt,
          DivisionCode: data.DivisionCode,
          ETADate: data.ETADate.toSaveDate(),
          FXPrice: data.SupplierFXPrice / data.SupplierConversion,
          IsVariable: data.IsVariable,
          ItemCode: data.ItemCode,
          ItemType: data.ItemType,
          LineNo: data.isNewRecord ? 0 : data.LineNo,
          Rank: data.Rank,
          RequiredQty: data.RequiredQty,
          RequiredByDate: data.RequiredByDate.toSaveDate(),
          SupplierConversion: data.SupplierConversion,
          SupplierRequired: data.SupplierRequired,
          SupplierUM: data.SupplierUM,
        };
        payload.PurchaseOrderDetails.push(detailObj);
      });

      return payload;
    },
    getPoDetailsSavePayload() {
      return poDetailsReviewListDataSource
        .items()
        .filter((x) => x.SupplierRequired > 0)
        .map((x) => {
          x.Rank = "1";
          x.ReduceSupplierRequisition = "N";
          x.UpdateStandardCost = "N";
          x.UpdateSupplierPrice = "N";
          let {
            BranchCode,
            Comment,
            CompanyCode,
            DiscPcnt,
            DivisionCode,
            ETADate,
            SupplierFXPrice,
            IsPrimeCostItem,
            IsVariable,
            ItemCode,
            ItemType,
            LineNo,
            Price,
            Rank, //
            ReduceSupplierRequisition, //
            RequiredQty,
            RequiredByDate,
            SupplierConversion,
            SupplierRequired,
            SupplierUM,
            TaxCode,
            UnitOfMeasureCode,
            UpdateStandardCost, //
            UpdateSupplierPrice, //
          } = x;
          return {
            BranchCode,
            Comment,
            CompanyCode,
            DiscPcnt,
            DivisionCode,
            ETADate,
            SupplierFXPrice,
            IsPrimeCostItem,
            IsVariable,
            ItemCode,
            ItemType,
            LineNo,
            Price,
            Rank, //
            ReduceSupplierRequisition, //
            RequiredQty,
            RequiredByDate,
            SupplierConversion,
            SupplierRequired,
            SupplierUM,
            TaxCode,
            UnitOfMeasureCode,
            UpdateStandardCost, //
            UpdateSupplierPrice, //
          };
        });
    },
    backButtonFunction() {
      this.$router.push({
        path: "/purchase-order",
      });
    },

    popUpBackButtonClick() {
      this.popupVisible = false;
      this.commentsPopupVisible = false;
    },
    popupLineCommentBackButtonClick() {
      this.updateDataSource(
        this.getCurrentPoDetailsDataSource(),
        currentRowIndex,
        "Comment",
        this.lineCommentModel.Comment
      );
      this.updateDataSource(
        this.getCurrentPoDetailsDataSource(),
        currentRowIndex,
        "IsCommentVisible",
        this.lineCommentModel.IsCommentVisible
      );
      this.lineCommentsPopupVisible = false;
    },
  },
};
</script>

<style lang="scss"></style>
